import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { countryOptions } from "layouts/views/common/options";
import { DateTimePickerField } from "ui-components/Form";

import { Fieldset } from "ui-components/Form";
import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";

const containerTypeOptions = [];
function ASN({ headerRender, poOptions = [], vendorOptions = [], control, errors, mode = "ADD" }) {
  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6 / 2;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "select":
        let options = [];
        switch (data.name) {
          case "vendorCode":
            options = vendorOptions;
            break;
          case "containerType":
            options = containerTypeOptions;
            break;
          case "sellerCountry":
            options = countryOptions;
            break;
          case "poNumber":
            options = poOptions;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
      case "datetime":
        renderField = <DateTimePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle
        title={
          mode === "EDIT"
            ? "Edit Advance Shipment Notice - PO Receiving"
            : "Add Advance Shipment Notice - PO Receiving"
        }
      />
      <MDBox mt={1.625}>
        {headerRender.map((rows, i) => {
          if (rows[0].type === "fieldset") {
            return (
              <Fieldset label={rows[0].label} key={i}>
                {rows[0].fieldsetRender.map((fs_rows, fs_i) => (
                  <Grid container spacing={3} key={fs_i}>
                    {fs_rows.map((fs_row, fs_index) => renderFn(fs_row, fs_index, fs_rows.length))}
                  </Grid>
                ))}
              </Fieldset>
            );
          }
          return (
            <Grid container spacing={3} key={i}>
              {rows.map((row, index) => renderFn(row, index, rows.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default ASN;
